import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../Modal/Modal";

interface EmailChangeAlertModalProps {
  show: boolean;
  onClose: () => void;
}

const EmailChangeAlertModal: FunctionComponent<EmailChangeAlertModalProps> = ({
  show,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={t("modal.emailChange.title")}
      description={t("modal.emailChange.description")}
      type="button"
      styleType="primary"
      linkTitle={t("common.hoCapito")}
      onFirstClick={onClose}
    />
  );
};

export default EmailChangeAlertModal;
